import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';

import StatusBadge from '../../../common/StatusBadge';
import DesktopComponent from './DesktopComponent';
import MobileComponent from './MobileComponent';
import Adaptive from '../../../common/Adaptive';

import {
  fetchGetPhysicalSetOrders,
  fetchCopyPhysicalSetOrder,
  fetchCancelPhysicalSetOrder,
  fetchUnloadingSetOfGoodsChestnyznak,
} from '../../../../actions/items';

import { downloadFileViaDirectLink, parseError } from '../../../../helpers';
import { saveAs } from 'file-saver';

import {
  PHYSICAL_SET_ORDER_ACTION_TYPES,
  PHYSICAL_SET_STATUS_TRANSLATE,
  PHYSICAL_SET_STATUS_STYLES,
} from '../../../../config';
import isMobile from 'ismobilejs';
import { showModal } from '../../../../actions/modal';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const PhysicalSetsJournal = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState([]);
  const [search, setSearch] = useState([]);
  const [loading, setLoading] = useState(false);

  const { t } = useAutoTranslation();

  const getOrders = async ({ page }) => {
    setLoading(true);
    const { physicalSetOrders, recordsTotal } = await dispatch(
      fetchGetPhysicalSetOrders({ search, page }),
    );
    setOrders(physicalSetOrders);
    setTotal(recordsTotal);
    setLoading(false);
  };

  useEffect(() => {
    (async function () {
      await getOrders({});
    })();
  }, [search]);

  const handleChangePage = async (page) => {
    await getOrders({ page });
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleNewItem = () => {
    history.push('/physical-set-order');
  };

  const handleCopyItem = async (item) => {
    setLoading(true);
    await dispatch(fetchCopyPhysicalSetOrder({ id: item.id }))
      .then(async () => {
        await getOrders({});
        toast.info(t('Задание на сборку успешно скопировано'));
      })
      .catch((err) => {
        toast.error(parseError(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleRemoveItem = async (item) => {
    setLoading(true);
    await dispatch(fetchCancelPhysicalSetOrder({ id: item.id }))
      .then(async () => {
        await getOrders({});
        toast.info(t('Задание на сборку успешно отменено'));
      })
      .catch((err) => {
        toast.error(parseError(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleUnloadingSetOfGoodsChestnyznak = async (itemId) => {
    const res = await dispatch(fetchUnloadingSetOfGoodsChestnyznak(itemId));

    saveAs(res.url, res.fileID);
  };

  const handleOpenModal = (checkedItem) => {
    dispatch(
      showModal('AdditionalDataSet', {
        checkedItem,
      }),
    );
  };

  const tableData = {
    cols: [t('Задача'), t('Комплект'), t('Статус'), t('Количество')],
    rows: orders.map((o) => ({
      key: o.id,
      item: o,
      isRemovable: o.status !== 'CANCELED',
      isCopyable: o.status !== 'CANCELED',
      data: [
        {
          value: (
            <>
              <div>{`${t('Задание')} ${o.id} от ${moment(o.createTs).format(
                'DD.MM.YYYY HH:mm',
              )}`}</div>
              <div className="text-muted">{o?.externalId}</div>
              <div>{PHYSICAL_SET_ORDER_ACTION_TYPES.find((t) => t.value === o.action)?.label}</div>
            </>
          ),
        },
        {
          value: (
            <Link to={`items/${o.physicalSet.productId}`}>
              <div>{o.physicalSet?.shortName}</div>
              <span className="ids-span">
                {o.physicalSet?.id}
                {o.physicalSet?.extId ?? null}
              </span>
            </Link>
          ),
          className: 'shortname-td shortname-link',
        },
        {
          value: (
            <StatusBadge
              status={o.status}
              translateData={PHYSICAL_SET_STATUS_TRANSLATE}
              stylesData={PHYSICAL_SET_STATUS_STYLES}
            />
          ),
        },
        {
          value: `${o.quantity} ${t('шт')}`,
        },
      ],
    })),
  };

  const adaptiveProps = {
    tableData: isMobile().any ? orders : tableData,
    search: isMobile().any ? search : undefined,
    loading,
    total,
    handleSearch,
    handleNewItem,
    handleCopyItem,
    handleRemoveItem,
    handleChangePage,
    handleUnloadingSetOfGoodsChestnyznak,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopComponent}
      MobileComponent={MobileComponent}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default PhysicalSetsJournal;
